import { z } from "zod";

// Skema untuk data anak (level agen di dalam ruangan)
const ReportRoomChildSchema = z.object({
    agent_name: z.string(),
    room_nights: z.number(),
    reservations: z.number(),
    avg_nights: z.string(),
    booking_window: z.string(),
    revenue: z.string(),
    ota_com: z.string(),
    avg_rate: z.string(),
    cancel_count: z.number(),
});

// Skema untuk data utama (level ruangan)
const ReportRoomDataV4Schema = z.object({
    room_type: z.string(),
    percentage: z.number(),
    room_nights: z.number(),
    reservations: z.number(),
    avg_nights: z.string(),
    booking_window: z.string(),
    revenue: z.string(),
    ota_com: z.string(),
    avg_rate: z.string(),
    cancel_count: z.number(),
    children: z.array(ReportRoomChildSchema),
});

// Skema untuk objek 'total' pada respons
const ReportRoomTotalSchema = z.object({
    percentage: z.number(),
    room_nights: z.number(),
    reservations: z.number(),
    avg_nights: z.string(),
    booking_window: z.string(),
    revenue: z.string(),
    ota_com: z.string(),
    avg_rate: z.string(),
    cancel_count: z.number(),
});

// Skema untuk keseluruhan respons API
export const ReportRoomResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(ReportRoomDataV4Schema),
    total: ReportRoomTotalSchema,
});

// Ekspor tipe TypeScript yang diambil dari skema Zod
export type ReportRoomResponseV4 = z.infer<typeof ReportRoomResponseV4Schema>;
export type ReportRoomDataV4 = z.infer<typeof ReportRoomDataV4Schema>;